module.exports = __webpack_public_path__ + "assets/img/bg7.a29a6402.gif";